// extracted by mini-css-extract-plugin
export default {"creditsDropdownPopup":"ujIbr1ZJsc7meX0fxj6n"};